import React from 'react'
import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

export interface UserEditorProps {
  place: number
  onClose: () => void
  userId?: number
}

const UserEditor = ({ place, onClose, userId }: UserEditorProps): React.ReactElement => {
  const { t } = useCustomTranslation()

  return (
    <Dialog
      title={t('user.userData.editUser')}
      onClose={() => onClose()}
      place={place}
      actions={{
        primary: {
          name: t('common.save'),
          onClick: () => onClose(),
        },
        secondary: [
          {
            name: t('common.cancel'),
          },
        ],
      }}
    >
      <div>User Editor</div>
      <div>userId: {userId} </div>
    </Dialog>
  )
}

export default UserEditor
